import { privateRequest, type ApiResponse } from "../axios";

const ENDPOINTS = {
  PURCHASE_ORDER_MASTER: "api/GetPurchaseOrdersMaster",
  PURCHASE_ORDER_ITEMS: "api/GetPurchaseItems",
  UPDATE_STATUS: "api/UpdatePurchaseStatus",
  ADD_ORDER: "api/AddPurchase",
  GET_PRODUCTS: "api/CRM/v1/Products",
  DELIVER_STATUS: "api/Invoice",
  GET_PURCHASE_PRODUCTS: "api/GetProductByPurchase",
  GET_PURCHASE_EXPORT: "api/ExportPurchaseMaster",
  GET_DISTRIBUTORS_LIST: "api/CRM/DistributorList",
}

const getSaleOrderMasterList = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.PURCHASE_ORDER_MASTER, { params: data });
  return res.data;
};

const getSaleOrderItemsList = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.PURCHASE_ORDER_ITEMS, { params: data });
  return res.data;
}

const updateSaleOrderStatus = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.UPDATE_STATUS, data);
  return res.data;
};

const addSaleOrder = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.ADD_ORDER, data);
  return res.data;
};

const getProductList = async (): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.GET_PRODUCTS);
  return res.data;
};

const updateDeliverStatus = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.DELIVER_STATUS, data);
  return res.data;
};

const getPurchaseProductList = async (purchaseId: number): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(`${ENDPOINTS.GET_PURCHASE_PRODUCTS}?purchaseId=${purchaseId}`);
  return res.data;
};

const getPurchaseExport = async (data: any) => {
  const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.GET_PURCHASE_EXPORT, { params: data, responseType: "arraybuffer" },);
  return res;
};

const getDistributorList = async (): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.GET_DISTRIBUTORS_LIST);
  return res.data;
};

const SalesOrderService = {
  updateSaleOrderStatus,
  addSaleOrder,
  getProductList,
  getSaleOrderMasterList,
  getSaleOrderItemsList,
  updateDeliverStatus,
  getPurchaseProductList,
  getPurchaseExport,
  getDistributorList,
};

export default SalesOrderService;